// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"2a54dc8e","963":"239f0535"}[chunkId] + ".chunk.js";
};